function immutableDescriptor(value) {
	return {
		configurable: false,
		enumerable: true,
		writable: true,
		value
	};
}

// For example Trustly (direct bank transfer) uses this
function externalHandler(executeWithdrawResult) {
	const handlerInfo = executeWithdrawResult.sendHandlerData.handler;
	const action = handlerInfo.externalUrl;
	const sendData = JSON.parse(handlerInfo.pageGsonParameter);

	const doc = window.document;
	const form = doc.createElement('form');
	form.action = action;
	form.method = 'POST';

	const fd = new FormData();
	Object.keys(sendData)
		.forEach(key => {
			fd.append(key, sendData[key]);
		});
	form.formData = fd;
	const body = doc.getElementsByTagName('body')[0];
	body.appendChild(form);
	form.target = '_self';
	form.submit();
}

// {"successful":true,"sendHandlerData":{"sendHandlerData":{"parameterMap":{}},"actualSendHandler":"PENDING_RESULT_AFTER_SINGLE_CALL"},"paymentFetchResultFlow":"/pp?flow\u003dGetWithdrawResult","accHistRef":"ST-0216823301468-369","errorMessage":{"title":"","message":""}}
function resultAfterSingleCallHandler() {
}

function pendingAfterSingleCallHandler(executeWithdrawResult) {
	const res = executeWithdrawResult;
	const AHR = 'accHistRef';
	const PFRF = 'paymentFetchResultFlow';
	const accHistParam = `${AHR}=${encodeURIComponent(res[AHR])}`;
	const resultFetchParam = `${PFRF}=${encodeURIComponent(res[PFRF])}`;
	window.location = `/payment/result/withdraw?${accHistParam}&${resultFetchParam}&fetch_type=fetch_type_synch&handlePaymentResultCallback=pendingAfterSingleCallback`;
}

function sendHandlerController() {
}

function internalPanelHandler() {
}

function asynchronousResultAfterSingleCallHandler() {

}

function externalWindowIframeHandler() {
}

const SEND_HANDLERS = {
	RESULT_AFTER_SINGLE_CALL: resultAfterSingleCallHandler,
	PENDING_RESULT_AFTER_SINGLE_CALL: pendingAfterSingleCallHandler,
	EXTERNAL_PANEL: externalHandler,
	EXTERNAL_WINDOW: externalHandler,
	SEND_HANDLER_CONTROLLER: sendHandlerController,
	INTERNAL_PANEL: internalPanelHandler,
	ASYNCHRONOUS_RESULT_AFTER_SINGLE_CALL: asynchronousResultAfterSingleCallHandler,
	EXTERNAL_WINDOW_IFRAME: externalWindowIframeHandler
};


/*
const zeData = {
	"methodId": 23,
	"methodName": "Trustly",
	"methodInfo": "??GLUEPAY_INFO_WITHDRAW??",
	"methodText": "Trustly",
	"executeUrl": "/TrustlyIntegration/executeWithdraw",
	"sendHandlerType": "EXTERNAL_PANEL",
	"logoImgClasses": ["gluepay en_gb"],
	"formTemplateCode": "NO-FIELDS",
	"formTemplateUrlParams": "\u0026paymentMethodId\u003d23\u0026paymentType\u003dwithdraw",
	"paymentType": "withdraw",
	"extraParameters": {}
};
*/
function paymentMethodFactory(methodData) {
	const data = {
		methodId: immutableDescriptor(methodData.methodId),
		methodText: immutableDescriptor(methodData.methodText),
		executeUrl: immutableDescriptor(methodData.executeUrl),
		sendHandlerType: immutableDescriptor(methodData.sendHandlerType),
		logoImgClasses: immutableDescriptor(methodData.logoImgClasses),
		formTemplateCode: immutableDescriptor(methodData.formTemplateCode),
		formTemplateUrl: immutableDescriptor(methodData.formTemplateUrl),
		formTemplateUrlParams: immutableDescriptor(methodData.formTemplateUrlParams),
		extraParameters: immutableDescriptor(methodData.extraParameters),
		accountId: immutableDescriptor(methodData.extraParameters)
	};


	const api = {

		send(executeResult) {
			/*
			const ccExecuteResult = {
				"successful": true,
				"sendHandlerData": {
					"sendHandlerData": { "parameterMap": {} },
					"actualSendHandler": "PENDING_RESULT_AFTER_SINGLE_CALL"
				},
				"paymentFetchResultFlow": "/pp?flow\u003dGetWithdrawResult",
				"accHistRef": "ST-0216823301468-369",
				"errorMessage": { "title": "", "message": "" }
			};
			const trustlyExecuteResult = {
				"successful": true,
				"sendHandlerData": {
					"HANDLER_CLASS": "se.cd.web.player.logic.payment.ExternalPanelInformation",
					"handler": {
						"externalUrl": "https://test.trustly.com/_/orderclient.php?SessionID\u003dd253f7b9-e034-4564-942c-e52d9b6fb9ee\u0026OrderID\u003d3770537931\u0026Locale\u003den_GB\u0026headerTextKey\u003dEXTERNAL_TRUSTLY_WITHDRAW_PANEL_HEADER",
						"externalParameters": {},
						"headerTextKey": "EXTERNAL_TRUSTLY_WITHDRAW_PANEL_HEADER",
						"openExternalPanelFlow": "providerAmountWithdrawPage",
						"pageGsonParameter": "{\"max_wd_amount\":\"362.92 SEK\",\"fee_amount\":\"0.00 SEK\",\"min_wd_amount\":\"198.00 SEK\"}",
						"actualSendHandler": "EXTERNAL_PANEL"
					}
				},
				"paymentFetchResultFlow": "/pp?flow\u003dGetTrustlyWithdrawResult",
				"accHistRef": "e49119c9-4885-411c-8810-9b864f55fe37",
				"errorMessage": { "title": "", "message": "" }
			};
			const piq = {
				"successful": true,
				"sendHandlerData": {
					"HANDLER_CLASS": "se.cd.web.player.logic.payment.SendHandlerControllerData",
					"handler": {
						"sendHandlerData": { "HANDLER_CLASS": "se.cd.web.player.logic.payment.SendHandlerMap", "handler": { "parameterMap": {} } },
						"actualSendHandler": "PENDING_RESULT_AFTER_SINGLE_CALL"
					}
				},
				"paymentFetchResultFlow": "/PaymentFormDataService/getWithdrawResultService",
				"accHistRef": "ST-0217076301791-30",
				"errorMessage": { "title": "", "message": "" }
			};
			*/

			if (!executeResult.successful) {
				throw new Error(`${executeResult.errorMessage.title}: ${executeResult.errorMessage.message}`);
			}
			const sendHandlerName = executeResult.sendHandlerData.actualSendHandler || executeResult.sendHandlerData.handler.actualSendHandler;
			SEND_HANDLERS[sendHandlerName](executeResult);
		}
	};

	return Object.create(api, data);
}
function createStore() {
	const methodTextReplacementString = {
		'CREDIT-CARD'(account) {
			return account.cardNo;

		}
	};
	const props = {
		account: {
			configurable: false,
			enumerable: true,
			writable: true,
			value: undefined
		},
		currency: {
			configurable: false,
			enumerable: true,
			writable: true,
			value: undefined
		},
		method: {
			configurable: false,
			enumerable: true,
			writable: true,
			value: undefined
		}
	};
	const api = {
		// kjbase.payment_method: Trustly, Credit Card...
		setMethod(paymentMethod) {
			this.method = paymentMethod;
			this.account = null;
		},
		getMethod() {
			return this.method;
		},
		/* User may have stored ”accounts” for some payment methods.
		 * For the Credit Card method, ”account” would be an actual card (card no, expiry etc)
		 */
		setAccount(account) {
			const getString = methodTextReplacementString[this.method.formTemplateCode];
			if (getString) {
				this.method.methodText = getString(account);
			}
			this.account = account;
		},
		getAccount() {
			return this.account;
		},
		setCurrency(currency) {
			this.currency = currency;
		},
		getCurrency() {
			return this.currency;
		},
			setLastUsedAmount(value) {
			this.lastAmount = value;
		},
		getLastUsedAmount() {
			return this.lastAmount;
		},
	};
	return Object.create(api, props);
}

export {
	paymentMethodFactory,
	createStore,
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/withdraw/payment-method-data.js